<template>
  <section id="profileWizardClient"  class="container section page">
      <div class="text-center mb-3">
          <h2>Profiel Wizard - Opdrachtgever</h2>
      </div>
      
    <horizontal-stepper id="stepper" class="p-1 p-md-5 mb-5" :steps="steps" :top-buttons="true" locale="nl" ref="wizard" :keep-alive="false"
    @completed-step="completeStep"  
    @active-step="isStepActive" 
    @stepper-finished="alert"
    @clicking-back="backStep"
    @before-next-step="next"></horizontal-stepper>
    <vue-toastr ref="toastr"></vue-toastr>
    
</section>
</template>

<script>
import HorizontalStepper from '@/components/VueStepper/HorizontalStepper';
import VueToastr from "vue-toastr";

const ProfileWizardOne = () => import(/* webpackChunkName: "client-wizard-pages" */'@/views/client/profile/wizard/1')
const ProfileWizardTwo = () => import(/* webpackChunkName: "client-wizard-pages" */'@/views/client/profile/wizard/2')
const ProfileWizardThree = () => import(/* webpackChunkName: "client-wizard-pages" */'@/views/client/profile/wizard/3')

export default {
        components: {
            HorizontalStepper,
            VueToastr
        },
        data(){
            return {
                steps: [
                    {
                        icon: 'exclamation-triangle',
                        name: 'ProfileWizardOne',
                        title: 'Bedrijfsgegevens',
                        subtitle: 'Uw gegevens',
                        component: ProfileWizardOne,
                        completed: false

                    },
                    {
                        icon: 'exclamation-triangle',
                        name: 'ProfileWizardTwo',
                        title: 'Betaalgegevens',
                        subtitle: 'Facturatie & Betaling',
                        component: ProfileWizardTwo,
                        completed: false
                    },
                    {
                        icon: 'exclamation-triangle',
                        name: 'ProfileWizardThree',
                        title: 'Voorwaarden',
                        subtitle: 'Overeenkomst',
                        component: ProfileWizardThree,
                        completed: false
                    },
                ]
            }
        },
        mounted() {
            this.$refs.toastr.defaultPosition = "toast-bottom-right";
        },
        methods: {
            next(currentStep, next) {
                let wizard = this.$refs.wizard;
                if(!wizard.$children[0].$v.form.$invalid)
                {
                    wizard.$children[0].isLoading = true;
                    return wizard.$children[0].setProfile().then(() => {
                        this.$refs.toastr.s("Opgeslagen!");
                        return next();
                    }).catch((res) => {
                        if(!!res.data)
                            this.$refs.toastr.e(res.data);
                        this.$refs.toastr.e("Opslaan mislukt!");

                        wizard.$children[0].$v.form.$reset();
                        wizard.$children[0].$v.form.$touch();
                    });
                } else {
                    return wizard.$children[0].$v.form.$touch();
                }
            },
            // Executed when @completed-step event is triggered
            completeStep(payload) {
                let wizard = this.$refs.wizard;
                this.steps.forEach((step) => {
                    if (step.name === payload.name) {
                        //wizard.$children[0].setProfile();
                        step.completed = true;
                    }
                })
            },
            backStep() {
                
            },
            // Executed when @active-step event is triggered
            isStepActive(payload) {
                this.steps.forEach((step) => {
                    if (step.name === payload.name) {
                        if(step.completed === true) {
                            step.completed = false;
                        }
                    }
                })
            },
            alert(payload)
            {
                //let wizard = this.$refs.wizard;
                //wizard.$children[0].setProfile().then(() => {
                    this.$store.dispatch('GET_USER', null).then(() => {
                        this.$refs.toastr.s("Wizard voltooid!");
                        this.$router.push({name: 'ClientProfile'});
                    });
                //})
                //alert('Bedankt voor het insturen van jou profiel. We beoordelen deze zo snel mogelijk.');
            }
        }
    }

</script>